import axios from "axios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useToasts } from "react-toast-notifications";
import base_url from "../../api/bootapi";
import { useStateValue } from "../../Registration/Components/ContextAPI/StateProvider";
import DeviceSettingGPSLeft from "./DeviceSettingGPSLeft";
import DeviceSettingGPSRight from "./DeviceSettingGPSRight";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const DeviceSettinggps = ({ token, imei_no, planid }) => {
  const classes = useStyles();
  const [loader, setloader] = useState(false);
  const [settingmodal, setsettingmodal] = useState(false);
  const { addToast } = useToasts();
  const [
    { devicesettinggps, activationType, bkpdevicesettinggps, odometer_value },
    dispatch,
  ] = useStateValue();

  const showsettingmodal = () => setsettingmodal(true);
  const closesettingmodal = () => {
    dispatch({
      type: "ADD_TO_DEVICESETTINGS_GPS",
      devicesetting: bkpdevicesettinggps,
    });
    dispatch({
      type: "ADD_TO_ODOMETERVALUE",
      odometer_value: "",
    });
    setsettingmodal(false);
  };

  const getimeidata = (val) => {
    // showsettingmodal();
    // return;
    setloader(true);
    axios
      .get(`${base_url}/api/device/settings/${val}?category=gps`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
      .then((res) => {
        const data = res.data.settings;
        if (activationType.unit === "MPH") {
          data.speed_limit = Number(data.speed_limit / 1.60934).toFixed(2);
        }
        dispatch({
          type: "ADD_TO_DEVICESETTINGS_GPS",
          devicesetting: data,
        });
        setTimeout(() => {
          setloader(false);
          showsettingmodal();
        });
      })
      .catch((err) => {
        if (err) {
          if (err.response) {
            addToast(err.response.data.message, {
              appearance: "error",
              autoDismiss: true,
            });
          } else {
            addToast("Something Went Wrong", {
              appearance: "error",
              autoDismiss: true,
            });
          }
        } else {
          addToast("Something Went Wrong", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        setloader(false);
      });
  };

  const updatedata = () => {
    if (!devicesettinggps.mobile_carrier) {
      return false;
    }
    if (activationType.unit === "MPH") {
      devicesettinggps.speed_limit = devicesettinggps.speed_limit * 1.60934;
    }
    axios
      .put(
        `${base_url}/api/device/settings/${imei_no}?category=gps`,
        devicesettinggps,
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
      .then((res) => {
        addToast("Device Update Successfully", {
          appearance: "success",
          autoDismiss: true,
        });
        closesettingmodal();

        if (odometer_value) {
          let odometer = odometer_value;
          if (activationType.unit === "MPH") {
            odometer = odometer_value * 1.60934;
          }
          let data = {
            imei: imei_no,
            odometer_value: odometer.toString(),
          };
          axios
            .post(`${base_url}/api/odometer/update?category=gps`, data, {
              headers: {
                Authorization: `JWT ${token}`,
              },
            })
            .then((res) => {
              addToast("Odometer Updated Successfully", {
                appearance: "success",
                autoDismiss: true,
              });
            });
        }
      })
      .catch((err) => {
        if (err.response) {
          addToast(`Error! ${err.response.data.message}`, {
            appearance: "error",
            autoDismiss: true,
          });
        } else {
          addToast(`Error! Something Went Wrong`, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      });
    dispatch({
      type: "ADD_TO_DEVICESETTINGS_GPS",
      devicesetting: bkpdevicesettinggps,
    });
    dispatch({
      type: "ADD_TO_ODOMETERVALUE",
      odometer_value: "",
    });
  };
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <p onClick={() => getimeidata(imei_no)} className="btn btn-primary">
        SETUP YOUR DEVICE
      </p>
      <Modal
        size="xl"
        show={settingmodal}
        onHide={() => closesettingmodal()}
        backdrop="static"
      >
        <Modal.Header closeButton={() => closesettingmodal()}>
          <Modal.Title>Device Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div
              className="col-md-6 confirm_deviceleft"
              style={{ borderRight: "2px solid #00a9e7" }}
            >
              <DeviceSettingGPSLeft planid={planid} />
            </div>
            <div className="col-md-6">
              <DeviceSettingGPSRight />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => updatedata()}
            type="button"
            className="btn btn-primary"
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeviceSettinggps;
